import sha256 from 'crypto-js/sha256';
import hex from 'crypto-js/enc-hex';

export function getCookie(key: string) {
  var arr,
    reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
  }
  return '';
}

export function isFormData(val: any) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

export function printGroupLog(
  title: string,
  content?: { [key: string]: any },
  style: boolean = true
) {
  console.group(title);
  content &&
    Object.keys(content).forEach(key => {
      style
        ? console.log(
            key,
            style || 'background: #222; color: #bada55',
            content[key]
          )
        : console.log(key, content[key]);
    });
  console.groupEnd();
}

export function decodeString(str: string) {
  if (typeof str !== 'string') {
    return str;
  }
  let result = str;
  while (decodeURIComponent(result) !== result) {
    result = decodeURIComponent(result);
  }
  return result;
}

export function objectToString(params: { [key: string]: any }) {
  return Object.keys(params)
    .map(key => {
      const decodedKey = decodeString(key);
      const decodedValue = decodeString(params[key]);
      if (typeof decodedValue === 'object') {
        return `${encodeURIComponent(decodedKey)}=${encodeURIComponent(
          JSON.stringify(decodedValue)
        )}`;
      } else {
        return `${encodeURIComponent(decodedKey)}=${encodeURIComponent(
          decodedValue
        )}`;
      }
    })
    .join('&');
}

export function stringToObject(data: string) {
  if (!data) {
    return {};
  }
  let result: { [key: string]: any } = {};
  data.split('&').forEach(item => {
    const [itemKey, itemValue] = item.split('=');
    result[itemKey] = itemValue;
  });
  return result;
}

/**
 * @param {string} str
 */
const writeUTF = (str: string) => {
  const value = str.toString();
  const back: any[] = [];
  let code;
  for (let i = 0; i < value.length; i++) {
    code = value.charCodeAt(i);
    if (0x00 <= code && code <= 0x7f) {
      back.push(code);
    } else if (0x80 <= code && code <= 0x7ff) {
      back.push(192 | (31 & (code >> 6)));
      back.push(128 | (63 & code));
    } else if (
      (0x800 <= code && code <= 0xd7ff) ||
      (0xe000 <= code && code <= 0xffff)
    ) {
      back.push(224 | (15 & (code >> 12)));
      back.push(128 | (63 & (code >> 6)));
      back.push(128 | (63 & code));
    }
  }
  for (let j = 0; j < back.length; j++) {
    back[j] &= 0xff;
  }
  return back;
};

const encrypt = (value: string) => {
  const result: any[] = [];
  let newCode: any[] = [];
  if (value === void 0) {
    return '';
  }
  newCode = writeUTF(value);
  for (let i = 0, length = newCode.length; i < length; ++i) {
    result.push((newCode[i] ^ 5).toString(16));
  }
  return result.join('');
};

/**
 * @param {object} params - what need to be encrypted
 * @param {string[]} keyList - the field to be encrypted
 */
export const encryptParams = (params: object, keyList: string[]) => {
  let value;
  let mix_mode = 0;
  let fixed_mix_mode = 0;
  if (typeof params !== 'object') {
    return params;
  }
  if (!keyList || keyList.length <= 0) {
    return params;
  }
  const newParams = { mix_mode, ...params } as any;
  for (let i = 0, length = keyList.length; i < length; ++i) {
    value = newParams[keyList[i]];
    if (value !== void 0) {
      mix_mode |= 1;
      fixed_mix_mode |= 1;
      newParams[keyList[i]] = encrypt(value);
    }
  }
  newParams.mix_mode = mix_mode;
  newParams.fixed_mix_mode = fixed_mix_mode;
  return newParams;
};

const sortObjectToString = (
  params: { [key: string]: any } = {},
  length: number = -1
) => {
  const sortedArr = Object.keys(params).sort() || [];
  if (length >= 0) {
    sortedArr.splice(length);
  }
  const str = sortedArr
    .map(key => {
      let value = params[key];
      if (typeof value === 'object') {
        return `${key}=${JSON.stringify(value)}`;
      } else {
        return `${key}=${value}`;
      }
    })
    .join('&');

  return { str, arr: sortedArr };
};

export const signature = (
  params: { [key: string]: any } = {},
  data: { [key: string]: any } = {},
  key: string = ''
) => {
  if (!key) {
    return {};
  }
  const { str: str1 = '', arr: arr1 = [] } = sortObjectToString(params, 10);
  const { str: str2 = '', arr: arr2 = [] } = sortObjectToString(data);

  const stringSignTemp = `${str1}&${str2}&app_key=${key}`;
  const digest = sha256(stringSignTemp);
  const sign = hex.stringify(digest);
  const qs = encrypt(arr1.join(','));
  return { sign, qs };
};
